import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
export function BannerCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const banners = [{
    image: 'https://cdn.magicpatterns.com/uploads/wunsQc2Q58F1Wd67Wk1QRx/Banner_arriba_web_1.webp',
    alt: 'Vacaciones sin ruido'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/3yLDmAgsNfvTMAjeCXVnmd/banner_arriba_web_2.webp',
    alt: 'Para que no te quemes, cuidate del sol y del ruido'
  }];
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  const goToNext = () => {
    setCurrentIndex(prev => (prev + 1) % banners.length);
  };
  const goToPrev = () => {
    setCurrentIndex(prev => (prev - 1 + banners.length) % banners.length);
  };
  return <section className="relative w-full bg-black" data-id="element-81">
      <div className="relative w-full" data-id="element-82">
        <div className="relative aspect-[16/9] sm:aspect-[21/9] w-full overflow-hidden" data-id="element-83">
          <AnimatePresence mode="wait" data-id="element-84">
            <motion.img key={currentIndex} src={banners[currentIndex].image} alt={banners[currentIndex].alt} className="absolute inset-0 h-full w-full object-cover" initial={{
            opacity: 0,
            scale: 1.05
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.95
          }} transition={{
            duration: 0.7,
            ease: 'easeInOut'
          }} data-id="element-85" />
          </AnimatePresence>

          {/* Navigation Buttons */}
          <button onClick={goToPrev} className="absolute left-4 top-1/2 z-10 -translate-y-1/2 rounded-full bg-black/30 p-2 text-white backdrop-blur-sm transition-all hover:bg-black/50 focus:outline-none focus:ring-2 focus:ring-white sm:left-8" aria-label="Banner anterior" data-id="element-86">
            <ChevronLeft className="h-6 w-6" data-id="element-87" />
          </button>

          <button onClick={goToNext} className="absolute right-4 top-1/2 z-10 -translate-y-1/2 rounded-full bg-black/30 p-2 text-white backdrop-blur-sm transition-all hover:bg-black/50 focus:outline-none focus:ring-2 focus:ring-white sm:right-8" aria-label="Siguiente banner" data-id="element-88">
            <ChevronRight className="h-6 w-6" data-id="element-89" />
          </button>

          {/* Dots Indicator */}
          <div className="absolute bottom-4 left-1/2 z-10 flex -translate-x-1/2 gap-2 sm:bottom-6" data-id="element-90">
            {banners.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`h-2 rounded-full transition-all ${index === currentIndex ? 'w-8 bg-white' : 'w-2 bg-white/50 hover:bg-white/75'}`} aria-label={`Ir al banner ${index + 1}`} data-id="element-91" />)}
          </div>
        </div>
      </div>
    </section>;
}